// #region Imports
import { defineComponent } from "vue";
// #endregion
export default defineComponent({
    // #region Computed
    computed: {
        _cultures() {
            return this.$appHost.getCultures();
        }
    },
    // #endregion
    // #region Methods
    methods: {
        setLang(culture) {
            if (culture.cultureID === this.$appHost.currentLang) {
                return;
            }
            this.$appHost.setLanguage(culture.culture, culture.uiCulture);
        }
    }
    // #endregion
});
